export class AdminDictionaryCountryDetailsForm {
  public constructor(
    private readonly data: {
      label: string;
      position: number;
      isoCode: string;
    },
  ) {}

  public get label(): string {
    return this.data.label;
  }

  public get position(): number {
    return this.data.position;
  }

  public get isoCode(): string {
    return this.data.isoCode;
  }
}
